import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

export interface TipoRiesgoVialItem {
  id: number;
  descripcion: string;
  estado: number;
  id_categoria?: number;
  categoria_id?: number;
  categoria?: number | { id?: number; nombre_categoria?: string };
  id_tipoprograma?: number;
  fechacreacion?: string;
  fechamodificacion?: string;
}

// 👇 lo que realmente se envía al crear (sin id, autogenerado por el backend)
export interface TipoRiesgoVialCreatePayload {
  descripcion: string;
  estado: number;
  id_tipoprograma: number; // 👈 usa el nombre real que espera tu backend
}

// 👇 payload para actualización parcial (no incluye estado, eso va por activar/inactivar)
export interface TipoRiesgoVialUpdatePayload {
  descripcion: string;
  id_tipoprograma: number;
}

@Injectable({ providedIn: 'root' })
export class TiposRiesgoVialService {
  private apiUrl = `${environment.apiUrl}/api/tipos_riesgo_vial`;

  constructor(private http: HttpClient) {}

  getAll(): Observable<TipoRiesgoVialItem[] | { data?: TipoRiesgoVialItem[] }> {
    return this.http
      .get<TipoRiesgoVialItem[] | { data?: TipoRiesgoVialItem[] }>(this.apiUrl, {
        withCredentials: true,
      })
      .pipe(catchError((error) => throwError(() => error)));
  }

  getByCategoria(categoriaId: number): Observable<TipoRiesgoVialItem[] | { data?: TipoRiesgoVialItem[] }> {
    return this.http
      .get<TipoRiesgoVialItem[] | { data?: TipoRiesgoVialItem[] }>(
        `${this.apiUrl}?categoria_id=${categoriaId}`,
        { withCredentials: true },
      )
      .pipe(catchError((error) => throwError(() => error)));
  }

  getByPrograma(programaId: number): Observable<TipoRiesgoVialItem[]> {
    return this.http
      .get<TipoRiesgoVialItem[]>(`${this.apiUrl}/programa/${programaId}`, {
        withCredentials: true,
      })
      .pipe(catchError((error) => throwError(() => error)));
  }

  getById(id: number | string): Observable<TipoRiesgoVialItem> {
    return this.http
      .get<TipoRiesgoVialItem>(`${this.apiUrl}/${id}`, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  create(payload: TipoRiesgoVialCreatePayload): Observable<TipoRiesgoVialItem> {
    return this.http
      .post<TipoRiesgoVialItem>(this.apiUrl, payload, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  // 🆕 Actualizar
  update(
    id: number | string,
    payload: TipoRiesgoVialUpdatePayload,
  ): Observable<TipoRiesgoVialItem> {
    return this.http
      .put<TipoRiesgoVialItem>(`${this.apiUrl}/${id}`, payload, {
        withCredentials: true,
      })
      .pipe(catchError((error) => throwError(() => error)));
  }

  // 🆕 Eliminar (si tu backend prefiere solo inactivar, usa inactivar() en su lugar)
  delete(id: number | string): Observable<any> {
    return this.http
      .delete<any>(`${this.apiUrl}/${id}`, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  // 🆕 Activar
  activar(id: number | string): Observable<any> {
    return this.http
      .put<any>(`${this.apiUrl}/${id}/activar`, {}, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  // 🆕 Inactivar
  inactivar(id: number | string): Observable<any> {
    return this.http
      .put<any>(`${this.apiUrl}/${id}/inactivar`, {}, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }
}